/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '@/store';

export default [
  {
    path: '/privacy',
    name: 'Privacy',
    view: 'legal/Privacy',
    meta: {
      title: 'Privacy Policy | Kubiqa',
      section: 'legal',
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    view: 'legal/Terms',
    meta: {
      title: 'Terms of Service | Kubiqa',
      section: 'legal',
    },
  },
  {
    path: '/',
    // Relative to /src/views
    view: 'Home',
    name: 'Home',
    meta: {
      //requiresAuth: true,
      section: 'home',
    },
  },
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard',
    name: 'Dashboard',
    meta: {
      requiresAuth: true,
      section: 'dashboard',
    },
  },
  {
    path: '/inbox',
    name: 'inbox',
    view: 'Inbox/Inbox',
    meta: {
      requiresAuth: true,
      section: 'leads',
    },
    children: [
      {
        path: '/inbox/:id',
        name: 'inboxItem',
        component: () => import('@/views/Inbox/Item.vue'),
        meta: {
          requiresAuth: true,
          section: 'leads',
        },
      },
    ],
  },
  {
    path: '/opportunities',
    name: 'opportunities',
    view: 'Opportunities/Main',
    components: {
      sidebar: () => import('@/views/Opportunities/Sidebar/Main.vue'),
    },
    meta: {
      requiresAuth: true,
      section: 'opportunities',
    },
  },
  {
    path: '/opportunities/:id',
    view: 'Opportunities/Item',
    name: 'opportunity-item',
    meta: {
      requiresAuth: true,
      section: 'opportunities',
    },
    children: [
      {
        path: 'detail',
        components: {
          default: () => import('@/views/Opportunities/Detail.vue'),
          sidebar: () => import('@/views/Opportunities/Sidebar/Main.vue'),
        },
        name: 'opportunityDetail',
        meta: {
          requiresAuth: true,
          section: 'opportunity',
        },
      },
      {
        path: 'tasks',
        component: () => import('@/views/Opportunities/Tasks.vue'),
        name: 'opportunityTasks',
        meta: {
          requiresAuth: true,
          section: 'opportunity',
        },
      },
      {
        path: 'pitches',
        component: () => import('@/views/Opportunities/Pitches.vue'),
        name: 'opportunityPitches',
        meta: {
          requiresAuth: true,
          section: 'opportunity',
        },
      },
      {
        path: 'activity',
        component: () => import('@/views/Opportunities/Activity.vue'),
        name: 'opportunityActivity',
        meta: {
          requiresAuth: true,
          section: 'opportunity',
        },
      },
      {
        path: 'files',
        component: () => import('@/views/Opportunities/Files.vue'),
        name: 'opportunityFiles',
        meta: {
          requiresAuth: true,
          section: 'opportunity',
        },
      },
    ],
  },
  {
    path: '/listings',
    view: 'Goods/Main',
    name: 'listings',
    meta: {
      requiresAuth: true,
      section: 'listings',
    },
  },
  {
    path: '/listings/:id',
    name: 'goodsItem',
    view: 'Goods/Item',
    meta: {
      requiresAuth: true,
      section: 'listings',
    },
  },
  {
    path: '/contacts',
    name: 'contacts',
    view: 'Contacts/Main',
    meta: {
      requiresAuth: true,
      section: 'contacts',
    },
  },
  {
    path: '/contacts/:id',
    name: 'contact',
    view: 'Contacts/Main',
    meta: {
      requiresAuth: true,
      section: 'contacts',
    },
  },
  {
    path: '/website',
    // name: 'website',
    view: 'Website/Main',
    meta: {
      requiresAuth: true,
      section: 'website',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Website/Page'),
        name: 'main',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
      {
        path: 'rent',
        // component: () => import('@/components/kubiqa/website/themes/' + store.state.website.theme + '/Rent.vue'),
        component: () => import('@/views/Website/Page'),
        name: 'rent',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
      {
        path: 'listing/:id',
        component: () => import('@/views/Website/Page'),
        name: 'listing',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
      {
        path: 'sale',
        component: () => import('@/views/Website/Page'),
        name: 'sale',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
      {
        path: 'contact',
        component: () => import('@/views/Website/Page'),
        name: 'contact',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
      {
        path: 'about',
        component: () => import('@/views/Website/Page'),
        name: 'about',
        meta: {
          requiresAuth: true,
          section: 'website',
        },
      },
    ],
  },
  {
    path: '/settings',
    view: 'Settings/Main',
    name: 'Settings',
    meta: {
      requiresAuth: true,
      section: 'settings',
    },
    children: [
      {
        path: 'company',
        component: () => import('@/views/Settings/Company.vue'),
        name: 'settingsCompany',
        meta: {
          requiresAuth: true,
          section: 'settings',
        },
      },
      {
        path: 'team',
        component: () => import('@/views/Settings/Team.vue'),
        name: 'settingsTeam',
        meta: {
          requiresAuth: true,
          section: 'settings',
        },
        children: [
          {
            path: ':id',
            component: () => import('@/views/Settings/Team/Item.vue'),
            name: 'settingsTeamItem',
            meta: {
              requiresAuth: true,
              section: 'settings',
            },
          },
        ],
      },
      {
        path: 'billing',
        component: () => import('@/views/Settings/Billing.vue'),
        name: 'settingsBilling',
        meta: {
          requiresAuth: true,
          section: 'settings',
        },
      },
    ],
  },
  {
    path: '/user',
    name: 'User Profile',
    view: 'User/Main',
    meta: {
      requiresAuth: true,
      section: 'profile',
    },
    children: [
      {
        path: '',
        redirect: 'profile',
      },
      {
        path: 'profile',
        component: () => import('@/views/User/Profile.vue'),
        name: 'userProfile',
        meta: {
          requiresAuth: true,
          section: 'profile',
        },
      },
      {
        path: 'password',
        component: () => import('@/views/User/Password.vue'),
        name: 'userPassword',
        meta: {
          requiresAuth: true,
          section: 'profile',
        },
      },
      {
        path: 'settings',
        component: () => import('@/views/User/Settings.vue'),
        name: 'userSettings',
        meta: {
          requiresAuth: true,
          section: 'profile',
        },
      },
    ],
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/typography',
    view: 'Typography',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/icons',
    view: 'Icons',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/maps',
    view: 'Maps',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    view: 'Notifications',
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/upgrade',
  //   name: 'Upgrade to PRO',
  //   view: 'Upgrade',
  //   meta: {
  //     requiresAuth: true,
  //     section: 'upgrade',
  //   },
  // },
  {
    path: '/register',
    name: 'Register',
    view: 'auth/Register',
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    view: 'auth/Upgrade',
    meta: {
      requiresAuth: true,
      requiresVerifiedEmail: true,
      section: 'home',
    },
  },
  {
    path: '/verification-required',
    name: 'Verification Required',
    view: 'auth/VerificationRequired',
    meta: {
      requiresAuth: true,
      section: 'home',
    },
  },
  {
    path: '/register/:invitation',
    name: 'Accept Invitation',
    view: 'auth/AcceptInvitation',
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: '/error',
    name: 'Error',
    view: 'Error',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    view: 'auth/ForgotPassword',
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    view: 'auth/ResetPassword',
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    view: 'auth/Login',
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: '/logout',
    // Relative to /src/views
    view: 'auth/Logout',
    meta: {
      requiresAuth: true,
    },
  },
];
